import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "", y = 32 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHead({ index, label, title, description, testId, dark = false }) {
  return (
    <div className="mb-14 max-w-2xl" data-testid={testId}>
      <Reveal>
        <div className="mb-4 flex items-center gap-3">
          <span className="font-mono text-xs text-[#B8860B]">{index}</span>
          <span className="h-px w-10 bg-[#B8860B]/40" />
          <span className={`font-mono text-xs uppercase tracking-[0.25em] font-semibold ${dark ? "text-[#2AA7A7]" : "text-[#0E8A8A]"}`}>{label}</span>
        </div>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className={`font-syne text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight ${dark ? "text-[#F8FAFC]" : "text-[#0F1B2B]"}`}>{title}</h2>
      </Reveal>
      {description && (
        <Reveal delay={0.16}>
          <p className={`mt-4 text-base leading-relaxed ${dark ? "text-[#8CA0B8]" : "text-[#5A6578]"}`}>{description}</p>
        </Reveal>
      )}
    </div>
  );
}
